import { useFeatureFlagsQuery } from '../useFeatureFlagsQuery';
export const useFeatureFlag = (featureFlagName) => {
    const { data } = useFeatureFlagsQuery();
    return !!data?.[featureFlagName];
};
